<template>
  <div>

    <search-select
      class="mv2"
      :options="managers"
      v-model="manager"
      placeholder="Управляющий"
      :search-enabled="true"
      bg="light"
    ></search-select>

    <div class="flex flex-column mv2 bg-light pv3 ph2">
      <span class="dib pv2 f6 mh2">Тип</span>
      <div class="flex radio-buttons-group">
        <template v-for="(dir, index) in bid_directions">
          <input :key="index" type='radio' :value='dir.id' name='direction' :id="dir.id + '_direction_f'" v-model="bid_direction"/>
          <label :key="index + 100" :for="dir.id + '_direction_f'" class="pv2 w4 f6">
            {{ dir.name }}
          </label>
        </template>
      </div>
    </div>

    <div class="flex flex-column mv2 bg-light pv3 ph2">
      <span class="mh2 text-secondary">Статус</span>
      <checkbox v-for="(stat, index) in statuses" :key="index" class="mt4 mt3-l mh2"
        :label="getStatusLabel(stat)"
        :value="stat.id"
        :checked="statusChecked(stat.id)"
        @change="toggleStatus"/>
    </div>

  </div>
</template>

<script>
import SearchSelect from '@/components/ui/SearchSelect.vue'
import Checkbox from '@/components/ui/Checkbox.vue'
import { idByIndex, indexById, addUniqueToArray, removeFromArray } from '@/utils/filters.js'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    SearchSelect,
    Checkbox
  },
  computed: {
    ...mapGetters('procedure', [
      'organizations', 'managers', 'bid_directions', 'periods', 'statuses', 'stats'
    ]),
    // organization: {
    //   get () {
    //     return indexById(this.organizations, this.$store.getters['procedure/filter/organization'])
    //   },
    //   set (value) {
    //     this.setOrganization(idByIndex(this.organizations, value))
    //   }
    // },
    manager: {
      get () {
        return indexById(this.managers, this.$store.getters['procedure/filter/manager'])
      },
      set (value) {
        this.setManager(idByIndex(this.managers, value))
      }
    },
    bid_direction: {
      get () { return this.$store.getters['procedure/filter/bid_direction'] },
      set (value) { this.setBidDirection(value) }
    },
    period: {
      get () { return this.$store.getters['procedure/filter/period'] },
      set (value) { this.setPeriod(value) }
    },
    status: {
      get () { return this.$store.getters['procedure/filter/status'] },
      set (value) { this.setStatus(value) }
    }
  },
  methods: {
    ...mapActions('procedure/filter', [
      'setOrganization', 'setManager', 'setBidDirection', 'setPeriod', 'setStatus'
    ]),
    statusChecked (id) {
      return this.$store.getters['procedure/filter/status'].includes(id)
    },
    toggleStatus (status) {
      const id = parseInt(status.value)
      const array = this.$store.getters['procedure/filter/status']
      this.setStatus(status.checked ? addUniqueToArray(array, id) : removeFromArray(array, id))
    },
    getStatusLabel (status) {
      const statusStats = (this.stats || {})[status.id]
      return statusStats
        ? `${status.name}(${statusStats})`
        : status.name
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
